module.exports = __webpack_public_path__ + "static/media/step2-top.b52f951a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step2-top.png
// module id = 3733
// module chunks = 0